import {Injectable} from '@angular/core';
import {DiscordMessageInterface} from '@models/discord-message.interface';
import {environment} from '@env/environment';

@Injectable({
    providedIn: 'root'
})
export class DiscordService {

    constructor() {
    }

    sendErrorChannelMessage(message: DiscordMessageInterface): void {
        const hook = environment.webhookDiscordError;
        this.setupDiscordRequest(hook, message);
    }

    sendDownloadsChannelMessage(message: DiscordMessageInterface): void {
        const hook = environment.webhookDiscordDownloads;
        this.setupDiscordRequest(hook, message);
    }

    sendDocumentChannelMessage(message: DiscordMessageInterface): void {
        const hook = environment.webhookDiscordDocument;
        this.setupDiscordRequest(hook, message);
    }

    sendProviderChannelMessage(message: DiscordMessageInterface): void {
        const hook = environment.webhookDiscord;
        this.setupDiscordRequest(hook, message);
    }

    sendHotelChannelMessage(message: DiscordMessageInterface): void {
        const hook = environment.webhookDiscordHotel;
        this.setupDiscordRequest(hook, message);
    }

    sendSemiMasterChannelMessage(message: DiscordMessageInterface): void {
        const hook = environment.webhookDiscordSemiMaster;
        this.setupDiscordRequest(hook, message);
    }

    sendUtilChanelMessage(message: DiscordMessageInterface): void {
        const hook = environment.webhookDiscordUtil;
        this.setupDiscordRequest(hook, message);
    }

    sendPolizasFianzasChannelMessage(message: DiscordMessageInterface): void {
        const hook = environment.webhookDiscordUPolizasFianzas;
        this.setupDiscordRequest(hook, message);
    }

    private setupDiscordRequest(hook: string, message: DiscordMessageInterface): void {
        try {
            const request = new XMLHttpRequest();
            request.open('POST', hook);
            request.setRequestHeader('Content-type', 'application/json');
            request.send(JSON.stringify(message));
        } catch (error) {
            console.error('Error sending Discord message:', error);
        }
    }
}
